import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const api = createApi({
    reducerPath: 'api',
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://script.google.com/macros/s'
    }),
    endpoints: builder => ({
        //Define endpoints here
        submitContactForm: builder.mutation({
            query: formData => ({
                url: '/AKfycbynJnko_hm_QR2ralGyBeFI8_8kM7oLjNVmZFBtoAa-LGcMZxHFP_YfXYM5017JPjCW/exec',
                method: 'POST',
                headers: {
                    "Content-Type": "text/plain;charset=utf-8"
                },
                body: JSON.stringify(formData)
            })
        }),
        getProducts: builder.mutation({
            query: () => ({
                url: '/AKfycbwEc5NBjUI83N0k-ZCwXfp_5zNieK5K9mztqftpanzOE9uBlynGHF2HMHapLD_qioE4tw/exec',
                method: 'POST',
                headers: {
                    "Content-Type": "text/plain;charset=utf-8"
                },
                body: JSON.stringify({method: 'getProducts'})
            })
        }),
        getPrices: builder.mutation({
            query: () => ({
                url: '/AKfycbwEc5NBjUI83N0k-ZCwXfp_5zNieK5K9mztqftpanzOE9uBlynGHF2HMHapLD_qioE4tw/exec',
                method: 'POST',
                headers: {
                    "Content-Type": "text/plain;charset=utf-8"
                },
                body: JSON.stringify({method: 'getPrices'})
            })
        }),
        createStripeCheckoutSession: builder.mutation({
            query: payload => ({
                url: '/AKfycbxd_1zXzCHMwoIJVKzNO2opMEYxijwAHXDsqxj2NcUr-Cjn-0Qx1GsnrTDV_ATL5F2xMQ/exec',
                method: 'POST',
                headers: {
                    'Content-Type': 'text/plain;charset=utf-8'
                },
                body: JSON.stringify(payload)
            })
        }),
        getOrderInfo: builder.mutation({
            query: payload => ({
                url: '/AKfycbxGiG4pLEWnfV-ZRj1-iTXeBr8Zvf0nBjqAszRWjGYwgqs6sO1G1T7-Kzei1q0auybxmw/exec',
                method: 'POST',
                headers: {
                    'Content-Type': 'text/plain;charset=utf-8'
                },
                body: JSON.stringify({method: 'getOrderInfo', checkoutSessionId: payload})
            })
        }),
        getOrderNumber: builder.mutation({
            query: payload => ({
                url: '/AKfycbxGiG4pLEWnfV-ZRj1-iTXeBr8Zvf0nBjqAszRWjGYwgqs6sO1G1T7-Kzei1q0auybxmw/exec',
                method: 'POST',
                headers: {
                    'Content-Type': 'text/plain;charset=utf-8'
                },
                body: JSON.stringify({method: 'getOrderNumber', checkoutSessionId: payload})
            })
        })
    })
})

export const {
    useSubmitContactFormMutation,
    useGetProductsMutation,
    useGetPricesMutation,
    useCreateStripeCheckoutSessionMutation,
    useGetOrderInfoMutation,
    useGetOrderNumberMutation
} = api;